export default "__VITE_ASSET__hMFRs5CF__"